import { useState, useEffect, useCallback } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import Form3 from './new-analysis/Form3';
import { loadSpecies, getAnalyses, loadMatrix } from '../utilities/httpRequest';
import { useNavigate } from 'react-router-dom';
import InputSelect from '../components/InputSelect';
import TextButton from '../components/TextButton';
import { ClipboardPlus } from 'lucide-react';
import { specieFromId } from '../utilities/utils';

export default function Simulation() {

    const navigate = useNavigate();

    const [analyses, setAnalyses] = useState([]);
    const [bilans, setBilans] = useState([]);
    const [matrix, setMatrix] = useState([""]);
    const [cost, setCost] = useState(0);
    const [specieId, setSpecieId] = useState("");

    const computeCost = useCallback(() => {
        let totalCost = 0;
        analyses.forEach((category) => {
            category.analyses.forEach((item) => {
                if (!(item.checked === false || item.checked === undefined) && (item.locked === false || item.locked === undefined)) {
                    totalCost = totalCost + Number.parseFloat(item.price);
                }
            })
            category.bilans.forEach((item) => {
                if (!(item.checked === false || item.checked === undefined)) {
                    totalCost = totalCost + Number.parseFloat(item.price);
                }
            })
        })
        bilans.forEach((item) => {
            if (!(item.checked === false || item.checked === undefined)) {
                totalCost = totalCost + Number.parseFloat(item.price);
            }
        })
        setCost(totalCost);
    }, [analyses, bilans]);
    useEffect(() => computeCost(), [computeCost]);

    //Chargement des données
    const [species, setSpecies] = useState([]);
    useEffect(() => { loadSpecies(setSpecies, navigate) }, [navigate]);
    useEffect(() => { loadMatrix(setMatrix, navigate) }, [navigate, setMatrix]);

    const getData = useCallback(async (specieId) => {
        const loadingElement = document.getElementById("loading");
        if(loadingElement) loadingElement.style.display = "flex";
        try {
            // Chargement des données en parallèle
            const { analysesData, bilansData } = await getAnalyses(specieId, navigate)
            // Mise à jour des états
            setAnalyses(analysesData);
            setBilans(bilansData);
        } catch (e) {
            console.error(e.message);
        } finally {
            if(loadingElement) loadingElement.style.display = "none";
        }
        document.getElementById("loading").style.display = "none";
    },[navigate]);

    useEffect(() => {
        specieId && getData(specieId);
    }, [specieId,getData])

    const goToPrescription = () => {
        const state = {
            initialAnalyses: analyses,
            initialBilans: bilans,
            initialSpecie: specieFromId(specieId, species),
            initialMatrix: matrix
        }
        navigate("/new_analysis", { state: state })
    }

    return (
        <>
            <SpecieSelectWindow specie={specieId} setSpecie={setSpecieId} species={species} />
            <div className="flex flex-col items-center py-5 gap-5">
                <TextButton className="text-lg" lucideIcon={<ClipboardPlus className="text-medium-green group-hover:text-white" />} text="Nouvelle prescription sur base de cette estimation" onClick={goToPrescription} />
                <Form3 hidden={false} cost={cost} specieId={specieId} analyses={analyses} setAnalyses={setAnalyses} matrix={matrix} setMatrix={setMatrix} bilans={bilans} setBilans={setBilans} />
            </div>
        </>

    )
}
function SpecieSelectWindow({ specie, setSpecie, species }) {

    const navigate = useNavigate();

    const [visible, setVisible] = useState(true);

    return (
        visible && (
            <div className="popup-bg">
                <div className="popup-window bg-white flex flex-col gap-5 p-5 m-auto" >
                    <div className="flex flex-col gap-2">
                        <p className="text-dark-green font-medium text-base">Veuillez choisir une espèce:</p>
                        <InputSelect placeholder="Espèce*" onChange={(e) => setSpecie(e.target.value)} options={species} defaultValue={specie} />
                    </div>
                    <div className="flex flex-col gap-2">
                        <TextButton className="" text="Valider" onClick={() => setVisible(false)} />
                        <TextButton className="" text="Annuler" red={true} onClick={() => navigate("/")} />
                    </div>
                </div>
            </div>
        ))
}